// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__yuA4_","productName":"Table_productName__3TR-M"};